import UsersAPI from "./UsersAPI";
import ApplicationsAPI from "./ApplicationsAPI";
import ConnectionsAPI from "./ConnectionsAPI";
import JobsAPI from "./JobsAPI";
import ApiKeysAPI from "./ApiKeysAPI";

class API
  implements IUsersAPI, IApplicationsAPI, IAccountAPI, IConnectionsAPI, IJobsAPI, IApiKeysAPI
{
  /* IUsersAPI */
  adminListUsers = UsersAPI.adminListUsers;
  adminGetUser = UsersAPI.adminGetUser;
  adminUpdateUser = UsersAPI.adminUpdateUser;
  adminCreateUser = UsersAPI.adminCreateUser;
  adminDeleteUser = UsersAPI.adminDeleteUser;

  userListUsers = UsersAPI.userListUsers;
  userGetUser = UsersAPI.userGetUser;
  userUpdateUser = UsersAPI.userUpdateUser;
  userGetUploadUrl = UsersAPI.userGetUploadUrl;
  userUploadPrivateFile = UsersAPI.userUploadPrivateFile;
  userUploadProtectedFile = UsersAPI.userUploadProtectedFile;
  userUploadPublicFile = UsersAPI.userUploadPublicFile;
  userValidatePassword = UsersAPI.userValidatePassword;

  /* IApplicationsAPI */
  getKetricsApplicationsRefreshToken = ApplicationsAPI.getKetricsApplicationsRefreshToken;

  adminListApplications = ApplicationsAPI.adminListApplications;
  adminGetApplication = ApplicationsAPI.adminGetApplication;
  adminUpdateApplication = ApplicationsAPI.adminUpdateApplication;
  adminCreateApplication = ApplicationsAPI.adminCreateApplication;
  adminDeleteApplication = ApplicationsAPI.adminDeleteApplication;
  adminUploadApplication = ApplicationsAPI.adminUploadApplication;
  adminUpdateApplicationUsers = ApplicationsAPI.adminUpdateApplicationUsers;

  userListApplications = ApplicationsAPI.userListApplications;
  userGetApplication = ApplicationsAPI.userGetApplication;

  /* IConnectionsAPI */
  adminListConnections = ConnectionsAPI.adminListConnections;
  adminGetConnection = ConnectionsAPI.adminGetConnection;
  adminCreateConnection = ConnectionsAPI.adminCreateConnection;
  adminUpdateConnection = ConnectionsAPI.adminUpdateConnection;
  adminDeleteConnection = ConnectionsAPI.adminDeleteConnection;

  /* IJobsAPI */
  adminListJobs = JobsAPI.adminListJobs;
  adminGetJob = JobsAPI.adminGetJob;
  adminCreateJob = JobsAPI.adminCreateJob;
  adminUpdateJob = JobsAPI.adminUpdateJob;
  adminDeleteJob = JobsAPI.adminDeleteJob;

  /* IApiKeysAPI */
  adminListApiKeys = ApiKeysAPI.adminListApiKeys;
  adminGetApiKey = ApiKeysAPI.adminGetApiKey;
  adminCreateApiKey = ApiKeysAPI.adminCreateApiKey;
  adminUpdateApiKey = ApiKeysAPI.adminUpdateApiKey;
  adminDeleteApiKey = ApiKeysAPI.adminDeleteApiKey;
}

export default new API();
